import React from 'react';
import { Icon } from 'Components';
import { OverviewCardProps } from 'LearningManager/components/OverviewCard';

export type OverviewCardData = Omit<OverviewCardProps, 'tooltip'> & {
	id: string;
	tooltip: string;
};

interface FilterOption {
	id: number;
	label: string;
}

export const PRIORITY_OPTIONS: FilterOption[] = [
	{ id: 1, label: 'High' },
	{ id: 2, label: 'Medium' },
	{ id: 3, label: 'Low' }
];

export const STATUS_OPTIONS: FilterOption[] = [
	{ id: 1, label: 'Not Started' },
	{ id: 2, label: 'In Progress' },
	{ id: 3, label: 'Completed' }
];

export const TYPE_OPTIONS: FilterOption[] = [
	{ id: 1, label: 'Course' },
	{ id: 2, label: 'Learning Path' },
	{ id: 3, label: 'Module' }
];

export const CATEGORY_OPTIONS: FilterOption[] = [
	{ id: 1, label: 'Compliance' },
	{ id: 2, label: 'Security' },
	{ id: 3, label: 'Leadership' },
	{ id: 4, label: 'Technical' }
];

export const OVERVIEW_CARDS_DATA: OverviewCardData[] = [
	{
		id: 'overall-completion',
		value: '77%',
		label: 'Overall Completion',
		description: 'Required courses only',
		icon: <Icon type="warningCubeIcon" role="img" />,
		tooltip: 'Percentage of required courses completed. This metric focuses only on mandatory training.'
	},
	{
		id: 'courses-remaining',
		value: 10,
		label: 'Course Remaining',
		description: 'Required courses only',
		icon: <Icon type="grayCourseIcon" role="img" />,
		tooltip: 'Number of required courses you still need to complete to meet your training obligations.'
	},
	{
		id: 'courses-complete',
		value: 33,
		label: 'Courses Complete',
		description: 'All finished training',
		icon: <Icon type="tickBoxIcon" role="img" />,
		tooltip: 'Total number of courses you have successfully completed across all learning paths.'
	},
	{
		id: 'optional-course',
		value: 1,
		label: 'Optional Course',
		description: 'Remaining to complete',
		icon: <Icon type="optionalCourseIcon" role="img" />,
		tooltip: 'Additional courses to enhance your skills and career development. Not required but recommended.'
	}
];
